const {MapValuesConfiguration} = require("./configuration/map-values-configuration");
const {PreviewTab} = require("../preview-tab/preview-tab");

const MapValuesStepTabs = {
    configuration: MapValuesConfiguration,
    preview: PreviewTab,
};
exports.MapValuesStepTabs = MapValuesStepTabs;
